import React from "react";
import PropTypes from "prop-types";
import { ReactDefaultProps } from "@/types/react";
import StringMap from "@/types/StringMap";

import { Heading, HeadingVariantMap, HeadingVariantValue } from "../Heading";

import styles from "./Modal.scss";

declare const validModalHeadingVariant: unique symbol;
export type ModalHeadingVariantMap = StringMap<
  "hint",
  typeof validModalHeadingVariant
> &
  HeadingVariantMap;
export type ModalHeadingVariantKey = keyof ModalHeadingVariantMap;
export type ModalHeadingVariantValue = ModalHeadingVariantMap[ModalHeadingVariantKey];

export type ModalHeadingProps = React.PropsWithChildren<{
  variant?: ModalHeadingVariantValue | ModalHeadingVariantValue[];
}>;

const defaultProps = {
  variant: Heading.Variant.secondary as ModalHeadingVariantValue,
  children: null,
} as const;

const validatedDefaultProps: ReactDefaultProps<
  ModalHeadingProps,
  typeof defaultProps
> = defaultProps;

export const ModalHeading = ({
  children,
  variant = defaultProps.variant,
  ...others
}: ModalHeadingProps): JSX.Element => (
  <div className={styles.heading}>
    <Heading tag="h2" variants={variant as HeadingVariantValue} {...others}>
      {children}
    </Heading>
  </div>
);

ModalHeading.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variant: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
} as const;

ModalHeading.defaultProps = validatedDefaultProps;

ModalHeading.Variant = {
  hint: Heading.Variant.secondary as ModalHeadingVariantValue,
} as const;

ModalHeading.displayName = "Modal.Heading";

export default ModalHeading;
